module.exports = __webpack_public_path__ + "img/coffee.10d8638a.svg";